import { httpClient } from '@/network/clientController'

/** Get Transfers Beneficiaries
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfersbeneficiaries
*/
export const requestBeneficiariesList = (params) => {
    return httpClient({
		method: 'GET',
		url: 'transfers/beneficiaries',
        params: params,
		isCancellable: true
	})
}

/** Get Transfers Beneficiaries by Data Type
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GETtransfersbeneficiariesbydatatype
*/
export const requestBeneficiariesListByDataType = (params) => {
    return httpClient({
		method: 'GET',
		url: 'transfers/beneficiaries/bydatatype',
        params: params,
		isCancellable: true
	})
}

/** Get Beneficiary name
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GETtransfersbeneficiariesname
*/
export const getBeneficiaryName = (params) => {
    return httpClient({
		method: 'GET',
		url: 'transfers/beneficiaries/name',
        params: params,
		isCancellable: true
	})
}

/** Get Beneficiary Info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GETtransfersbeneficiariesdestinationinfo
*/
export const getBeneficiaryDestinationInfo = (params) => {
    return httpClient({
		method: 'GET',
		url: 'transfers/beneficiaries/destination/info',
        params: params,
		isCancellable: true
	})
}

/** Deletes Transfer Beneficiary
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETE_transfersbeneficiaries%7Bid%7D
*/
export const deleteBeneficiary = (payload) => {
	return httpClient({
		method: 'DELETE',
		url: `transfers/beneficiaries/${payload}`
	})
}

/** Creates Transfer Beneficiary
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_transfersbeneficiaries
*/
export const createBeneficiary = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'transfers/beneficiaries',
		data: payload,
		operationTypeId: 92 /* for mocks handling of tokens */
	})
}

/** Edit Transfer Beneficiary
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_transfersbeneficiaries%7Bid%7D
*/
export const editBeneficiary = (payload) => {
	return httpClient({
		method: 'PUT',
		url: `transfers/beneficiaries/${payload.id}`,
		data: payload.data,
		operationTypeId: 93 /* for mocks handling of tokens */
	})
}
